export default __webpack_public_path__ + "static/media/plus.b92f49d4.svg";